import {Injectable, Injector} from '@angular/core';
import {ApiService} from './api.service';
import {SiteInfosService} from './site-infos.service';
import {HttpParams} from '@angular/common/http';
import {Room} from '@app/core';
import {map} from 'rxjs/operators';
import {forEach, find, orderBy, map as _map} from 'lodash';

const routes = {
  resaInfo: '/resa-info',
};

@Injectable({
  providedIn: 'root'
})
export class AchatsService {


  readonly extraPayments: Array<any> = [
    {
      id: 1,
      name : 'static.cartebancaire'
    },
    {
      id: 2,
      name : 'stripe'
    },
    {
      id: 3,
      name : 'paypal'
    },
    {
      id: 4,
      name : 'static.hotelsecurepaymentpci'
    },
    {
      id: 5,
      name : 'CMI'
    },
    {
      id: 6,
      name : 'static.virementversement'
    },
    {
      id: 7,
      name : 'static.virementelectronique'
    },
    {
      id: 8,
      name : 'static.alagence'
    },
    {
      id: 10,
      name : 'static.payzone'
    },
    {
      id: 11,
      name : 'static.payexpress'
    },
    {
      id: 14,
      name : 'static.paiementenligne'
    },
  ];
  paymentTypesList: Array<any> = [
    /*{
      id: 100,
      name : 'static.siteweb'
    },

    {
      id: 104,
      name : 'static.wafacash'
    },*/
  ];
  constructor(private apiService: ApiService) {

  }


    loadResaInfo(ruid: string) {
        const params = new HttpParams({
            fromObject: {
                ruid: ruid,
            }
        });
        return this.apiService.get(routes.resaInfo, params).pipe(map((response: {status, response:any }) => {
            if (response.status === 1 && response.response.payement_list) {
                _map(response.response.payement_list, (v: {ruid: string, payement: Array<any>}, k) => {
                    v.payement.forEach((val) => {
                        val['ruid'] = ruid;
                    })
                });
                this.addpaymentModes(response.response.payement_list);
            }
            return response;
        })).toPromise();
    }

  createpaymentInfosList({ruid, payement_list}){
    const list = {};

    for (const p of Object.keys(payement_list)) {
      const array = [];
      for (const item of payement_list[p].payement) {
        array.push(item);
      }

      list[p] = {
        ruid,
        info : array,
      };
    }
    return list;
  }

  loadRooms(packs){
    const roomsInfos = [];
    packs.forEach(pack => {
      pack.packCombines.forEach(item => {
        roomsInfos.push(item);
      });
    });
    return roomsInfos;
  }

  addpaymentModes(list: Array<{order: number, payement:Array<any>}>){
        let paymentTypesList = [];
        forEach(list, (value, idModePay) => {
            let item = find(this.extraPayments, {id: parseInt(idModePay)});
            !!item ? paymentTypesList.push({...item, ...value}): null;
        })
      this.paymentTypesList = orderBy(paymentTypesList, 'order', 'asc');
  }


}
